import yargs from 'yargs';
import chalk from 'chalk';

import { initializeCommand } from '../index';
import { initializeProject } from '../project';
import { Listr } from 'listr2';

export const command = 'init <projectDirectory>';
export const describe = `Generate the project boilerplate in the current working directory.`;

export const builder = (argv: yargs.Argv): yargs.Argv =>  {
  yargs.option('force', {
    describe: `Flag to force an initialization even though the directory is not empty.`,
    type: 'boolean',
    default: false,
  }).alias('f', 'force');

  initializeCommand();
  
  return argv;
};

export const handler = async(argv: any): Promise<void> => {
  const projectDirectory: string = argv?.projectDirectory ?? ``;
  const force: boolean = !!argv?.force ?? false;

  const taskRunner = new Listr([{
    title: `Creating project at ${chalk.underline(`./${projectDirectory}/`)}`,
    task: async (): Promise<void> => {
      await initializeProject(projectDirectory, force);
    },
  }]);

  await taskRunner.run();  
};
